export default "__VITE_ASSET__zcFDvt2A__"